import React from 'react'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

interface SelectorData {
  code: number | string
  name: string
}

interface SelectorProps {
  datas: SelectorData[]
  labelName: string
  value?: number | string | null
  update: (value: any) => void
  showCode?: boolean
  width?: string
  placeholder?: string
  className?: string
  id?: string
  onOpenChange?: (open: boolean) => void
  loading?: boolean
}

export const Selector: React.FC<SelectorProps> = ({
  datas,
  labelName,
  value,
  update,
  showCode,
  width,
  placeholder,
  className,
  id,
  onOpenChange,
  loading,
}) => {
  const stringValue =
    value !== null && value !== undefined ? String(value) : undefined

  return (
    <Select
      // Radix Select 清空为 undefined 时不会回到 placeholder，需 remount
      key={stringValue ?? `${labelName}-empty`}
      onOpenChange={onOpenChange}
      onValueChange={(val) => {
        // 尝试将值转换回原始类型
        const numVal = Number(val)
        update(isNaN(numVal) ? val : numVal)
      }}
      value={stringValue}
    >
      <SelectTrigger id={id} className={cn(width || 'w-[180px]', className)}>
        <SelectValue placeholder={placeholder || `Select a ${labelName}`} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>{labelName}</SelectLabel>
          {loading ? (
            <div className="px-2 py-1.5 text-sm text-muted-foreground">
              Loading...
            </div>
          ) : (
            datas.map((item) => (
              <SelectItem key={item.code} value={String(item.code)}>
                {showCode && `${item.code} - `}
                {item.name}
              </SelectItem>
            ))
          )}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export default Selector
